// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBatteryVerticalCharging40 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.5h-4zm5 3H9a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5.83l-.31 1.551c-.031.157-.04.307-.03.449H9a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v5.42a1.485 1.485 0 0 0-1.53.695l-.47.734V6a1 1 0 0 0-1-1zm1.55 13.775h-2.325a.298.298 0 0 1-.153-.043.292.292 0 0 1-.093-.406l3.544-5.537a.285.285 0 0 1 .37-.107.282.282 0 0 1 .162.321l-.055.272-.75 3.75h2.325c.23 0 .37.255.246.449L17.98 20.35l-1.413 2.208-.29.452c-.174.272-.595.102-.531-.215zM13.942 20H9.25a.25.25 0 0 1-.25-.25v-5.1a.25.25 0 0 1 .25-.25h5.5c.08 0 .15.037.197.095l-2.02 3.157c-.605.944-.03 2.16 1.015 2.348z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBatteryVerticalCharging40;
